app.service('basketPackageModal', function (modal) {

	function open(mainId) {
		const modalContent = $('#package-modal-content-' + mainId).html();
		modal.generate({
			id: 'modal-package-content',
			modifier: 'remodal-right',
			content: modalContent
		});
	}

	return {
		open
	};
});
